'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'car-wrench';
var width = 512;
var height = 512;
var aliases = ["car-mechanic"];
var unicode = 'f5e3';
var svgPathData = 'M153.7 64c-6.4 0-12.1 3.8-14.7 9.6-9.9 22.6-32.5 38.4-58.7 38.4-23.7 0-44.4-12.9-55.4-32l55.4 0c17.7 0 32-14.4 32-32-.2-17.5-14.4-32-32-32L25 16c11.1-19.1 31.8-32 55.4-32 26.2 0 48.8 15.8 58.7 38.4 2.5 5.8 8.3 9.6 14.7 9.6l205.3 0c6.4 0 12.1-3.8 14.7-9.6 9.9-22.6 32.5-38.4 58.7-38.4 23.7 0 44.4 12.9 55.4 32l-55.4 0c-17.6 0-31.9 14.4-32 32 0 17.5 14.4 32 32 32l55.4 0c-11.1 19.1-31.8 32-55.4 32-26.2 0-48.8-15.8-58.7-38.4-2.5-5.8-8.3-9.6-14.7-9.6L153.7 64zM80.4 64L2 64c7.4 36.5 39.7 64 78.4 64 32.8 0 61-19.7 73.3-48l205.3 0c12.3 28.3 40.5 48 73.3 48 38.7 0 71-27.5 78.4-64l-78.4 0c-8.8 0-16-7.3-16-16.1 .1-8.8 7.2-15.9 16-15.9l78.4 0c-7.4-36.5-39.7-64-78.4-64-32.8 0-61 19.7-73.3 48L153.7 16C141.4-12.3 113.2-32 80.4-32 41.7-32 9.4-4.5 2 32l78.4 0c8.8 0 15.9 7.2 16 16 0 8.8-7.1 16-16 16zm75.3 96l201.4 0c17.5 0 33 11.4 38.2 28.1l26.3 84.1c-1.7-.1-3.4-.2-5.2-.2l-320 0c-1.7 0-3.5 .1-5.2 .2l26.3-84.1c5.2-16.7 20.7-28.1 38.2-28.1zm-53.5 23.3L73.2 276.4c-23.9 9.3-40.8 32.5-40.8 59.6l0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 320 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144c0-27.1-16.9-50.3-40.8-59.6l-29.1-93.1c-7.3-23.4-29-39.3-53.5-39.3l-201.4 0c-24.5 0-46.1 15.9-53.5 39.3zM432.4 432l-384 0 0-96c0-26.5 21.5-48 48-48l320 0c26.5 0 48 21.5 48 48l0 96-32 0zm0 48l0-32 32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16zm-352-32l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 32 0zm32-96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm224-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCarWrench = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;